<template>
  <v-card-title class="text-h5 justify-center wordBreak">
    <h2 class="headline primary--text text--accent-2">
      <slot></slot>
    </h2>
  </v-card-title>
</template>

<script>
export default {
  name: 'DialogBaseTitle'
}
</script>
